import boletaApi from "./boletaApi";

export const getInteresInvoice = async (period) => {
  try {
    return await boletaApi.get("/interesInvoice", { params: { period } });
  } catch (error) {
    const { response } = error;
    return response;
  }
};
